export enum OrderPaymentStatus {
  PROCESSING = 'processing',
  AUTHORIZED = 'authorized',
  PAID = 'paid',
  REFUNDED = 'refunded',
  PENDING = 'pending',
  PENDING_REFUND = 'pending_refund',
  REFUSED = 'refused',
  CHARGEDBACK = 'chargeback',
  ANALYZING = 'analyzing',
  PENDING_REVIEW = 'pending_review',
  CHECKOUT_ABANDONED = 'checkout_abandoned',
  AWAITING = 'awaiting',
  RECURRENCY = 'recurrency',
  CANCELED = 'canceled',
  PARTIAL_REFUND = 'partial_refund',
  EXPIRED_BILLET = 'expired_billet',
  PAYMENT_FAILED = 'payment_failed'
}

export const OrderPaymentStatusLabels = {
  [OrderPaymentStatus.PROCESSING]: 'Processando',
  [OrderPaymentStatus.AUTHORIZED]: 'Autorizado',
  [OrderPaymentStatus.PAID]: 'Pago',
  [OrderPaymentStatus.REFUNDED]: 'Reembolsado',
  [OrderPaymentStatus.PENDING]: 'Pendente',
  [OrderPaymentStatus.PENDING_REFUND]: 'Pendente de reembolso',
  [OrderPaymentStatus.REFUSED]: 'Recusado',
  [OrderPaymentStatus.CHARGEDBACK]: 'Devolvido',
  [OrderPaymentStatus.ANALYZING]: 'Analisando',
  [OrderPaymentStatus.PENDING_REVIEW]: 'Pendente de revisão',
  [OrderPaymentStatus.CHECKOUT_ABANDONED]: 'Checkout abandonado',
  [OrderPaymentStatus.AWAITING]: 'Aguardando',
  [OrderPaymentStatus.RECURRENCY]: 'Recorrencia',
  [OrderPaymentStatus.CANCELED]: 'Cancelado',
  [OrderPaymentStatus.PARTIAL_REFUND]: 'Reembolso parcial',
  [OrderPaymentStatus.EXPIRED_BILLET]: 'Boleto expirado',
  [OrderPaymentStatus.PAYMENT_FAILED]: 'Pagamento falhou',
}